import {
  component_styles_default
} from "./chunk.BKUJPVXD.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/credit-card/credit-card.styles.ts
var credit_card_styles_default = r` ${component_styles_default} :host { position: relative; } .credit-card__svg, .credit-card__tooltip { display: flex; } .credit-card__svg { width: 40px; } .credit-card__svg svg { width: 40px; height: 26px; } .credit-card--monochrome { color: var(--sl-color-neutral-0); } `;

export {
  credit_card_styles_default
};
